var map = {
	"./3d.jpg": "8b0b",
	"./aleksandr.webp": "1ddc",
	"./forChild.webp": "6940",
	"./forParents.webp": "7916",
	"./forProgramer.webp": "e1e4",
	"./grisha.webp": "0861",
	"./ilya.webp": "0ac1",
	"./java.jpg": "342b",
	"./logo.png": "9d64",
	"./natalya.webp": "97fb",
	"./paralax.webp": "d8cb",
	"./proto.jpg": "686c",
	"./python.jpg": "2682",
	"./q1.jpg": "ea0c",
	"./q10.jpg": "da76",
	"./q11.jpg": "94e9",
	"./q2.jpg": "da53",
	"./q3.jpg": "a233",
	"./q5.jpg": "3109",
	"./q7.jpg": "a3f3",
	"./q8.jpg": "6a33",
	"./q9.jpg": "371f",
	"./roman.webp": "4336",
	"./saveliy.webp": "e437",
	"./scratch.jpg": "7d4f",
	"./sergey.webp": "31c0",
	"./uca.jpg": "4345",
	"./uka.webp": "a67f",
	"./valentin.webp": "9e81",
	"./web.jpg": "1827"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";